import ReactDragListView from './ReactDragListView';
import ReactDragColumnView from './ReactDragColumnView';

ReactDragListView.DragColumn = ReactDragColumnView;
export default ReactDragListView;